export default "__VITE_ASSET__BG5TF3Ss__"